export default __webpack_public_path__ + "static/media/Tiger's Armguards of the Roaring Jungle.d91140c2.jpg";